import { fromJS } from 'immutable';

import { reportEntities } from './types';

export * from './actions';

const reportEntitiesReducerObject = {
  [reportEntities.request]: (state) => state.setIn(['reportEntities', 'network', 'loading'], true),
  [reportEntities.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['reportEntities', 'network', 'loading'], false)
        .setIn(['reportEntities', 'network', 'error'], false)
        .setIn(['reportEntities', 'data'], fromJS(action.response)),
    ),
  [reportEntities.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['reportEntities', 'network', 'loading'], false)
        .setIn(['reportEntities', 'network', 'error'], action.error),
    ),
};

export default reportEntitiesReducerObject;
